import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { get } from 'transport/utils/http';
import getQueryParams from 'shared/utils/get-query-params';
import WixSDK from 'shared/utils/wix-sdk';

const ACTIONS = createAsyncActions('SERVER.EXPERIMENTS');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


function getExperimentsFromUrl() {
  return WixSDK.Settings.getSiteInfo()
    .then(function ({ url }) {
      const queryParams = getQueryParams(url);

      const { experiments = '' } = queryParams;
      return _.reduce(experiments.split(','), function (acc, name) {
        if (name) {
          return { ...acc, [name]: 'true' };
        }
        return acc;
      }, {});
    });
}

export default function () {
  return function (dispatch) {
    dispatch(START());

    const experimentsUrl = 'https://www.wix.com/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=vod';

    return Promise.all([
        get(experimentsUrl),
        getExperimentsFromUrl(),
      ])
      .then(
        function ([response, expsFromUrl]) {
          dispatch(SUCCESS({}, { ...response.data, ...expsFromUrl }));
        },

        function (response) {
          dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'shared.experiments.get' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/experiments/get.js